export default {
    CRAWL_ALL: 'SOURCE_INVOICE.CRAW.*',
    CRAWL_START: 'SOURCE_INVOICE.CRAW.START',
    CRAWL_FINISH: 'SOURCE_INVOICE.CRAW.FINISH',
    CRAWL_CANCEL: 'SOURCE_INVOICE.CRAW.CANCEL',
    CRAWL_PROCESSING: 'SOURCE_INVOICE.CRAW.PROCESSING',
    CRAWL_SUCCESS: 'SOURCE_INVOICE.CRAW.SUCCESS',
    CRAWL_FAILED: 'SOURCE_INVOICE.CRAW.FAILED',
};
